.list {
  display: grid;
  gap: var(--sp-12);
  max-width: 52rem;
}
